import styled from 'styled-components';
import Dialog from '~src/shared/dialogs/dialog/Dialog';

export const HeaderContainer = styled.div`
  display: flex;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.baseBlue.a10};
  padding: 15px 30px;
  border-top: 7px solid ${({ theme }) => theme.black.a1};
  line-height: 30px;
  align-items: center;
  > span {
    margin-left: 5px;
  }
`;

export const ScaleModalHeader = styled.div`
  display: flex;
  font-size: 17px;
  color: ${({ theme }) => theme.baseBlue.a10};
  padding: 15px;
  line-height: 30px;
  align-items: baseline;
  > span {
    margin-left: 5px;
  }
`;

export const ScaleContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.baseBlue.a10};
`;

export const DialogStyled = styled(Dialog)`
  div.ant-modal-content {
    overflow: hidden;

    .ant-modal-close-x {
      color: unset;
      font-size: 16px;
    }

    .ant-modal-body {
      padding: 0;
    }
  }

  .scale {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    background: rgba(78, 84, 107, 1);
  }
`;
